import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-288e20de"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_2 = { class: "text-end" }
const _hoisted_3 = { class: "d-flex flex-column justify-content-center h-60px" }
const _hoisted_4 = { class: "mb-1" }
const _hoisted_5 = { class: "text-gray-400" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { colspan: "9" }
const _hoisted_12 = { class: "d-flex flex-column justify-content-center align-items-center h-60px" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_common_product = _resolveComponent("common-product")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tableData, (row, j) => {
      return (_openBlock(), _createElementBlock("tr", {
        class: "subtable_template fulfillment-order text-start",
        key: j
      }, [
        _hoisted_1,
        _createVNode(_component_common_product, {
          gallery: row.gallery,
          brand_id: row.brand,
          brand_article_no: row.brand_article_no,
          product_identifier_id: '0',
          source_link: '',
          name: row.name,
          name_en: row.name_en,
          color: row.original_color,
          size: row.size,
          productCol: 4,
          skuCol: 2
        }, null, 8, ["gallery", "brand_id", "brand_article_no", "name", "name_en", "color", "size"]),
        _createElementVNode("td", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.t("order.qty")), 1),
            _createElementVNode("span", _hoisted_5, _toDisplayString(parseInt(row.quantity)), 1)
          ])
        ]),
        _hoisted_6,
        _hoisted_7,
        _hoisted_8,
        _hoisted_9
      ]))
    }), 128)),
    (_ctx.tableData.length == 0)
      ? _withDirectives((_openBlock(), _createElementBlock("tr", _hoisted_10, [
          _createElementVNode("td", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.isRequest ? "No data found" : ""), 1)
          ])
        ])), [
          [_directive_loading, _ctx.loading]
        ])
      : _createCommentVNode("", true)
  ], 64))
}